var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 3.09375C6.875 2.14408 7.645 1.375 8.59375 1.375H8.9375C9.84918 1.375 10.7235 1.73716 11.3682 2.38182C12.0128 3.02648 12.375 3.90082 12.375 4.8125V6.53125C12.375 7.48092 13.145 8.25 14.0938 8.25H15.8125C16.7242 8.25 17.5985 8.61216 18.2432 9.25682C18.8878 9.90148 19.25 10.7758 19.25 11.6875V14.7812C19.25 15.73 18.48 16.5 17.5312 16.5H8.59375C8.13791 16.5 7.70074 16.3189 7.37841 15.9966C7.05608 15.6743 6.875 15.2371 6.875 14.7812V3.09375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.81287C13.7516 3.65654 13.3352 2.53859 12.5776 1.66504C14.1114 2.06834 15.5106 2.87181 16.6321 3.99327C17.7536 5.11473 18.557 6.51394 18.9603 8.04779C18.0868 7.29015 16.9688 6.87377 15.8125 6.87537H14.0937C14.0026 6.87537 13.9151 6.83916 13.8507 6.77469C13.7862 6.71022 13.75 6.62279 13.75 6.53162V4.81287ZM4.46875 5.50037H5.5V14.7816C5.5 15.6021 5.82595 16.389 6.40614 16.9692C6.98633 17.5494 7.77324 17.8754 8.59375 17.8754H15.125V18.9066C15.125 19.8554 14.355 20.6254 13.4062 20.6254H4.46875C4.01291 20.6254 3.57574 20.4443 3.25341 20.122C2.93108 19.7996 2.75 19.3625 2.75 18.9066V7.21912C2.75 6.26946 3.52 5.50037 4.46875 5.50037Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.de422a746910c373c6494980d64e9187.svg";
export { ForwardRef as ReactComponent };